<div class="content_wrap_section">
    <div class="wrap_header_sectons contact_us_background">
        <div class="top_header_overlay"></div>
        <h1>문의하기 </h1>
    </div>

    <div class="contactus_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="office_address">
                        <div class="office_contents">
                            <h4>- 본사</h4>
                            <span style="font-size: 18px;font-weight: 600;">Crimson AI Pvt. Ltd.</span>
                            <p>8A, 8th Floor, Techniplex II, SV Road,<br /> Goregaon West, Mumbai,<br /> Maharashtra 400062, India </p>
                        </div>
                        <div class="office_contents">
                            <h4>-지사</h4>
                            <p>(06110) 서울특별시 강남구 학동로<br/>2길 19, 2층 2541호<br/>
                                크림슨인터랙티브코리아(주)</p>
                        </div>
                        <div class="office_contents">
                            <h4>연락처</h4>
                            <!-- <p>Phone no.+91-22-61935000</p> -->
                            <p>이메일: <a href="mailto:support@trinka.ai">support@trinka.ai</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="contact_forms">
                        <form [formGroup]="contactForm" (ngSubmit)="processForm()"> 
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group"
                                [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                    <!-- <input type="text" formControlName="contactFormName" class="form-control" placeholder="이름 *">
                                    <div class="error_msg_section" *ngIf="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine)">
                                        <p>이름은 필수 사항입니다.</p>
                                    </div> -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>이름 *</mat-label>
                                        <input matInput placeholder="" formControlName="contactFormName"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group"
                                [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                    <!-- <input type="text"  formControlName="contactFormEmail" class="form-control" placeholder="이메일 *">
                                    <div class="error_msg_section" *ngIf="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine)">
                                        <p>이메일은 필수 사항입니다.</p>
                                    </div> -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>이메일 *</mat-label>
                                        <input matInput placeholder="" formControlName="contactFormEmail"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-sm-12">
                                <div class="form-group"
                                [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>제목 *</mat-label>
                                        <input matInput placeholder="" formControlName="contactFormSubjects"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div> -->
                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormContactNumber').valid && contactForm.get('contactFormContactNumber').dirty) || (contactForm.get('contactFormContactNumber').touched && contactForm.get('contactFormContactNumber').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>연락처 * (ISD 코드 포함)</mat-label>
                                        <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormContactNumber"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormOrgTitle').valid && contactForm.get('contactFormOrgTitle').dirty) || (contactForm.get('contactFormOrgTitle').touched && contactForm.get('contactFormOrgTitle').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>조직 / 직함 *</mat-label>
                                        <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormOrgTitle"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group textareaBox"
                                [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                    <!-- <textarea name="containt" formControlName="contactFormMessage" class="form-control" placeholder="메시지 *. . ."></textarea>
                                    <div class="error_msg_section message_error" *ngIf="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine)">
                                        <p>메시지는 필수 사항입니다.</p>
                                    </div> -->
                                    <mat-form-field appearance="outline">
                                        <mat-label>메시지 *</mat-label>
                                        <textarea matInput formControlName="contactFormMessage" placeholder=""
                                            class="form-control"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group">
                                    <button type="submit">메시지 보내기</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="global_offices">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h2>우리의 글로벌 존재</h2>
                <div class="HeadingSubLine"></div>
                <p>우리는 연구 커뮤니티에 서비스를 쉽게 제공하기 위해 전 세계에 지사를 두고 있습니다.</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">New Jersey,<br/> USA</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20 active" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name">Seoul, Korea </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20 show" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.<br>
                                                #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu,
                                                Seoul, Republic of Korea    
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Beijing / Shanghai, China</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap"  style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South
                                                    Street,
                                                    Haidian District, Beijing, China - 100086<br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District,
                                                    Shanghai
                                                    200233<br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Tokyo, Japan</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.<br>
                                                4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo,
                                                101-0021,
                                                Japan<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Mumbai, India</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20 " id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive<br>
                                                1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road,
                                                Goregaon (W), Mumbai 400062, India<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">London, United Kingdom</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12
                                                0DR, United Kingdom<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Istanbul,<br />Turkey</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul,
                                                TURKEY<br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Taipei,<br> Taiwan</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1, <br>
                                                Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>
   
                            </div>    
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>